/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _CtcaeEditionForm;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from "@ember/object";
import { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import { ForcBaseArgs } from "core/components/forc/abstract/base-component";
import CtcaeFilledJournalEvent, { Question, Section } from "core/models/ctcae-filled-journal-event";
import { sleep } from "core/utils/time";
import dayjs from "dayjs";
import { toLeft, toRight } from "ember-animated/transitions/move-over";
import { IntlService } from "ember-intl";
import emberSwal from "ui-kit/utils/ember-swal";
import CtcaeBaseForm from "../base-form";
let CtcaeEditionForm = (_class = (_CtcaeEditionForm = class CtcaeEditionForm extends CtcaeBaseForm {
  rules({
    oldItems,
    newItems
  }) {
    if (oldItems[0] < newItems[0]) {
      return toLeft;
    }
    return toRight;
  }
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "currentSectionIndex", _descriptor, this);
    _initializerDefineProperty(this, "currentQuestionIndex", _descriptor2, this);
    _initializerDefineProperty(this, "currentQuestionTotalIndex", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _defineProperty(this, "duration", 300);
    if (this.ctcaeFilledInTheLast24Hours) {
      emberSwal.fire({
        text: `Vous avez déjà rempli un questionnaire le ${this.intl.formatDate(this.ctcaeFilledInTheLast24Hours.occurredAt, {
          format: "DD/MM/YYYY"
        })}. Voulez-vous appliquer les mêmes réponses ?`,
        icon: "question",
        cancelButtonText: "Annuler",
        showCancelButton: true,
        confirmButtonText: "Appliquer les réponses",
        confirmButtonColor: "#d33"
      }).then(result => {
        if (result.isConfirmed) {
          const sectionsToCopy = this.ctcaeFilledInTheLast24Hours?.sectionsWithAnswers;
          this.sections.forEach(section => {
            section.questions.forEach(question => {
              const sectionToCopy = sectionsToCopy.find(_section => _section.id == section.id);
              if (sectionToCopy) {
                const questionToCopy = sectionToCopy.questions.find(_question => _question.type == question.type);
                if (questionToCopy) {
                  question.answer = questionToCopy.answer;
                }
              }
            });
          });
        }
      });
    }
  }
  get ctcaeFilledInTheLast24Hours() {
    const lastCtcaeFilledJournalEvent = this.args.patient.lastCtcaeFilledJournalEvent;
    if (lastCtcaeFilledJournalEvent && lastCtcaeFilledJournalEvent.occurredAt > dayjs().subtract(2, "d").startOf("day").toDate()) {
      return lastCtcaeFilledJournalEvent;
    }
    return undefined;
  }
  get currentSection() {
    return this.sections[this.currentSectionIndex];
  }
  get currentQuestion() {
    return this.currentSection?.questions[this.currentQuestionIndex];
  }
  get totalNumberQuestions() {
    return this.sections.reduce((acc, obj) => {
      return acc + obj.questions.length;
    }, 0);
  }
  get currentAnswers() {
    return CtcaeFilledJournalEvent.typeToValue(this.currentQuestion?.type);
  }
  get isLastQuestion() {
    return this.currentSectionIndex == this.sections.length - 1 && this.currentQuestionIndex == this.currentSection.questions.length - 1;
  }
  async previousQuestion() {
    this.currentQuestionTotalIndex--;
    await sleep(this.duration / 2);
    if (this.currentQuestionIndex > 0) {
      this.currentQuestionIndex--;
    } else if (this.currentSectionIndex > 0) {
      this.currentSectionIndex--;
      this.currentQuestionIndex = this.currentSection.questions.length - 1;
    }
  }
  async nextQuestion() {
    const questions = this.currentSection.questions;
    this.currentQuestionTotalIndex++;
    await sleep(this.duration / 2);
    if (this.currentQuestionIndex < questions.length - 1) {
      this.currentQuestionIndex++;
    } else if (this.currentSectionIndex < this.sections.length - 1) {
      this.currentSectionIndex++;
      this.currentQuestionIndex = 0;
    }
  }
  async onChange(value) {
    this.currentQuestion.answer = value;
    if (this.isLastQuestion) {
      const result = await emberSwal.fire({
        text: `Vous avez complété votre questionnaire. Voulez-vous sauvegarder ?`,
        icon: "question",
        cancelButtonText: "Annuler",
        showCancelButton: true,
        confirmButtonText: "Sauvegarder",
        confirmButtonColor: "#d33"
      });
      if (result.isConfirmed) {
        await this.saveAndTransition();
      }
    } else {
      this.nextQuestion();
    }
  }
  async saveAndTransition() {
    await this.save();
    if (this.afterCompleted) {
      await this.afterCompleted();
    }
  }
}, _defineProperty(_CtcaeEditionForm, "fullComponentId", "ctcae/edition-form"), _defineProperty(_CtcaeEditionForm, "journalEventClass", CtcaeFilledJournalEvent), _CtcaeEditionForm), _descriptor = _applyDecoratedDescriptor(_class.prototype, "currentSectionIndex", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "currentQuestionIndex", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "currentQuestionTotalIndex", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "previousQuestion", [action], Object.getOwnPropertyDescriptor(_class.prototype, "previousQuestion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nextQuestion", [action], Object.getOwnPropertyDescriptor(_class.prototype, "nextQuestion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveAndTransition", [action], Object.getOwnPropertyDescriptor(_class.prototype, "saveAndTransition"), _class.prototype), _class);
export { CtcaeEditionForm as default };